import React from 'react'
import { RecyclingInfoModalProps } from './types'


const RecyclingInfoModalContent = (props: RecyclingInfoModalProps) => {
    return <div className='content-wrapper' dangerouslySetInnerHTML={{__html: props.cmsContent}}></div>
}

export default RecyclingInfoModalContent